import React from 'react';
import { Typography, Theme, Box, makeStyles, useTheme } from '@material-ui/core';
import CardSheet from '../../../components/CardSheet';
import EditPencil from '../../../components/EditPencil';
import { StyledText } from '../../../components/StyledText';
import DetectLinks from '../../../components/DetectLinks';


const useStyles = makeStyles<Theme>((theme: Theme) => ({
  separator: {
    height: '1px',
    width: '100%',
    backgroundColor: '#DAD9DF'
  },
  linksBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

interface ConnectorExpectationCardProps {
  content: string,
  editHandler?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const ConnectorExpectationCard: React.FC<ConnectorExpectationCardProps> = ({
  content,
  editHandler
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const contentPadding = editHandler ? '0px 32px 34px 32px' : '34px 32px';

  return (
    <CardSheet>
      <Box display={editHandler ? 'flex' : 'none'} marginTop='16px' marginRight='13px' justifyContent='flex-end'>
        <EditPencil onClick={editHandler} />
      </Box>
      <Box display='flex' flexDirection='column' height='auto' padding={contentPadding}>
        <Typography variant='h2'>
          Referral Expectation
        </Typography>
        <br />
        <StyledText variant='body1'>
          <DetectLinks content={content} />
        </StyledText>
      </Box>
    </CardSheet>
  );
};

export default ConnectorExpectationCard;
